module.exports = __webpack_public_path__ + "static/img/newLogo-pc.12cf04d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newLogo-pc.svg
// module id = EUvy
// module chunks = 1